<p *ngIf="label">{{ label }}</p>

<p>{{ text }}</p>
